export const getWairauValleyData = () => ({
  name: "Wairau Valley",
  region: "Marlborough",
  country: "Nouvelle-Zélande",
  description: "La Wairau Valley est la vallée principale de Marlborough et le cœur de la production de Sauvignon Blanc en Nouvelle-Zélande. Cette vallée alluviale bénéficie d'un climat maritime unique avec des étés chauds et secs et des nuits fraîches, créant des conditions idéales pour la viticulture.",
  type: "subregion",
  area: "15,000 ha",
  production: "1.4 million hectolitres",
  climate: "Climat maritime avec étés chauds et secs, nuits fraîches, précipitations modérées",
  soil: "Sols alluviaux, graviers, argiles, excellente diversité géologique",
  characteristics: {
    climate: "Climat maritime avec étés chauds et secs, nuits fraîches, précipitations modérées",
    soil: "Sols alluviaux, graviers, argiles, excellente diversité géologique",
    viticulture: "Innovation technologique, viticulture durable, rendements contrôlés"
  },
  wineStyles: {
    white: "Sauvignon Blanc aromatique avec notes de fruits de la passion, agrumes et herbes",
    red: "Pinot Noir élégant avec tanins fins et notes de fruits rouges",
    rosé: "Rosés frais et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture dans la Wairau Valley a commencé dans les années 1970 avec les premiers vignobles commerciaux. Le Sauvignon Blanc est rapidement devenu le cépage emblématique de la vallée, produisant des vins avec une personnalité unique reconnue mondialement. Aujourd'hui, la Wairau Valley est le centre de la production viticole de Marlborough.",
  foodPairing: "Fruits de mer, poissons blancs, salades fraîches, fromages de chèvre, cuisine asiatique",
  grapeVarieties: [
    {
      name: "Sauvignon Blanc",
      percentage: "80%",
      description: "Cépage emblématique de la vallée, produisant des vins aromatiques avec des notes de fruits de la passion",
      characteristics: "Aromatique, acidité vive, notes tropicales",
      wineStyles: "Sec, frais, aromatique"
    },
    {
      name: "Pinot Noir",
      percentage: "12%",
      description: "Cépage rouge principal, produisant des vins élégants avec des tanins fins",
      characteristics: "Élégant, tanins fins, fruits rouges",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Chardonnay",
      percentage: "5%",
      description: "Cépage blanc produisant des vins secs et équilibrés",
      characteristics: "Sec, équilibré, notes de fruits blancs",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Pinot Gris",
      percentage: "3%",
      description: "Cépage blanc produisant des vins aromatiques et texturés",
      characteristics: "Aromatique, texturé, notes d'épices",
      wineStyles: "Sec à demi-sec, aromatique"
    }
  ],
  statistics: {
    totalArea: "15,000 ha",
    production: "1.4 million hectolitres",
    wineries: "100+ domaines",
    exportPercentage: "85%"
  },
  viticulture: "La viticulture dans la Wairau Valley se caractérise par l'innovation technologique et la durabilité. Les rendements sont contrôlés pour préserver la qualité et l'intensité aromatique. L'irrigation est utilisée pour optimiser la croissance des vignes.",
  winemaking: "La vinification se fait principalement en acier inoxydable pour préserver la fraîcheur et les arômes primaires. La fermentation à basse température et l'utilisation de levures sélectionnées sont courantes. L'élevage sur lies est parfois pratiqué pour ajouter de la texture.",
  terroir: "La Wairau Valley est une vallée alluviale formée par la rivière Wairau. Les sols sont principalement composés de graviers et d'argiles déposés par la rivière au fil des millénaires. Le climat maritime apporte des influences océaniques qui modèrent les températures.",
  mapAreas: [
    { region: "Wairau Valley", x: 173.8, y: -41.5, color: "#4B164C", size: 6 }
  ]
}); 